var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"analyse-container",style:({'marginTop':_vm.peizhi['m-t'],'padding-top':_vm.peizhi['p-t']})},[_c('div',{staticClass:"analyse-container-img"},[_c('img',{attrs:{"src":require("@/assets/img/gjh/weitu.png")}}),_c('p',[_vm._v(_vm._s(_vm.desc)+_vm._s(_vm.defaultValue))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }